import ApiProcessor from '../../processors/api-processor'
import get from 'lodash/get'

const TABLE_FILTERS = [
  {
    attribute: 'createdBy.firstName',
    label: 'Username',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'action',
    label: 'Action',
    type: 'select',
    icon: 'el-icon-document',
    values: [
      {
        label: 'Created',
        value: 'create',
      },
      {
        label: 'Updated',
        value: 'update',
      },
      {
        label: 'Deleted',
        value: 'delete',
      },
    ],
  },
  {
    attribute: 'createdAt',
    label: 'Date',
    type: 'date',
    icon: 'el-icon-date',
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdBy.firstName',
    label: 'Username',
    format: (_, row) => {
      const { createdBy } = row
      return createdBy ? `${createdBy.firstName} ${createdBy.lastName}` : '—'
    },
    icon: 'el-icon-document',
  },
  {
    name: 'action',
    label: 'Action',
    format(_, row) {
      const { action, entityType, data } = row

      switch (entityType) {
        case 'Retailer':
          switch (action) {
            case 'create':
              return `New ${entityType} Created - ${get(data, 'meta.retailer.name')}`
            case 'update':
              return `${entityType} Updated - ${get(data, 'meta.retailer.name')}`
            case 'delete':
              return `${entityType} Deleted - ${get(data, 'meta.retailer.name')}`
            default:
              return '—'
          }
        case 'Category':
          switch (action) {
            case 'create':
              return `New ${entityType} - ${get(data, 'changeSet.name')}`
            case 'update':
              return `Updated ${entityType} - ${get(data, 'changeSet.name')}`
            case 'delete':
              return `Deleted ${entityType} - ${get(data, 'changeSet.name')}`
            default:
              return ''
          }
        case 'Offer':
          switch (action) {
            case 'create':
              return `New ${entityType} Created - ${get(data, 'meta.offer.name')} - ${get(data, 'meta.retailer.name')}`
            case 'update':
              return `${entityType} Updated - ${get(data, 'meta.offer.name')} - ${get(data, 'meta.retailer.name')}`
            case 'delete':
              return `${entityType} Deleted - ${get(data, 'meta.offer.name')} - ${get(data, 'meta.retailer.name')}`
            default:
              return '—'
          }
        default:
          return '—'
      }
    },
    icon: 'el-icon-document',
  },
  {
    name: 'createdAt',
    label: 'Date',
    icon: 'el-icon-date',
    format: 'dateTimeLong',
  },
  { type: 'expand' },
]

export default component => {
  return {
    processor: new ApiProcessor({
      component,
      path: 'action-logs',
      initialDataQuery: {
        sort: { createdAt: 'desc' },
        pageSize: 25,
      },
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'log',
  }
}
